import { render, staticRenderFns } from "./BrintellixTypingDialog.vue?vue&type=template&id=a3315432&scoped=true"
import script from "./BrintellixTypingDialog.vue?vue&type=script&lang=js"
export * from "./BrintellixTypingDialog.vue?vue&type=script&lang=js"
import style0 from "./BrintellixTypingDialog.vue?vue&type=style&index=0&id=a3315432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3315432",
  null
  
)

export default component.exports